import { useRouteState } from '../../hooks/routeStateHooks';
import { PAGE_NAMES } from '../../constants/Navigation';
import { NAVBAR_ITEMS } from './navbarConstants';

const getActivePageName = (nonNavPageSelected, nonNavPagePreviouslySelected, currentPageName, previousPageName) => {
  if (nonNavPageSelected) {
    if (nonNavPagePreviouslySelected || !previousPageName) {
      return PAGE_NAMES.CATALOG;
    } else {
      return previousPageName;
    }
  } else {
    return currentPageName;
  }
};

export const useNavigationState = pageName => {
  const {
    backLink,
    pageName: currentPageName,
    previousPageName
  } = useRouteState();
  const nonNavPageSelected = !!currentPageName && !NAVBAR_ITEMS.includes(currentPageName);
  const nonNavPagePreviouslySelected = !!previousPageName && !NAVBAR_ITEMS.includes(previousPageName);
  const active = currentPageName === pageName;
  const activePageName = getActivePageName(nonNavPageSelected, nonNavPagePreviouslySelected, currentPageName, previousPageName);
  return {
    pageName,
    backLink,
    currentPageName,
    previousPageName,
    hasNavigatedFromNavbarItem: nonNavPageSelected && pageName === previousPageName,
    isActive: activePageName === pageName || active,
    activePageName,
    nonNavPageSelected,
    nonNavPagePreviouslySelected
  };
};